module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d92ec58", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d92ec58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-slick/slickCarousel.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4d92ec58"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-slick/slickCarousel.vue
// module chunks = 0